module.exports = __webpack_public_path__ + "img/11.3fbea37b.png";